import React from 'react'
import { connect } from 'react-redux'
import imgFeatureList1 from '../../images/public/chalkboard-teacher.png'
import imgFeatureList2 from '../../images/public/diagnoses.png'
import imgFeatureList3 from '../../images/public/laptop-code.png'
import Header from '../partials/Header.jsx'
import Footer from '../partials/Footer.jsx'
import SupportList from '../partials/SupportList.jsx'
import CallToActRegister from '../partials/CallToActRegister.jsx'
import BlogList from '../partials/BlogList.jsx'

class ArticlesTechnicalHiring extends React.Component {
	componentDidMount() {
		window.scrollTo(0, 0)
	}

  render() {

    return (
			<main>
      <section className="homepage-feature">
				<Header isNavbarFixed={true} />
				<div className="homepage-feature-list bg-technical">
          <div className="container">
            <h2 className="heading1 m-b-76">Astronaut for Technical Hiring</h2>
            <div className="flex flex-around">
              <div className="feature-list-item">
                <div className="feature-list-image">
									<img src={imgFeatureList1} alt="Evaluate soft skill" />
                </div>
                <div className="heading4 bold">
									EVALUATE SOFT SKILL
                </div>
              </div>
              <div className="feature-list-item">
                <div className="feature-list-image">
									<img src={imgFeatureList2} alt="Question to test logic and experience" />
								</div>
                <div className="heading4 bold">
                  QUESTION TO TEST LOGIC <br />& EXPERIENCE
                </div>
              </div>
              <div className="feature-list-item">
                <div className="feature-list-image">
									<img src={imgFeatureList3} alt="Link with deeper code testing" />
								</div>
                <div className="heading4 bold">
                  LINK WITH DEEPER CODE <br />TESTING
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
			<section className="article-page-title">
				<div className="heading2">Case Study</div>
				<div className="heading1 larger">Contact us for more details.</div>
			</section>
      <SupportList />
      <CallToActRegister />
			<BlogList />
      <Footer />
    </main>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
	return {
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(ArticlesTechnicalHiring)
